<template>
  <td :class="[`cell-value-${col}`]">
    <router-link :to="{ name: editName, params: { id: entry._id } }">
      <span :class="[{ 'label-deploying' : isDeploying }]">
        {{ entry[col] }}
      </span>
      <span v-if="isDeploying && col === 'label'" :key="`indicator-${col}`" class="text-primary">
        <font-awesome-icon icon="spinner" spin />
      </span>
    </router-link>
  </td>
</template>

<script>
export default {
  computed: {
    isDeploying() {
      const found = this.flags.find(
        item => item.id === this.entry._id && item.flag === 'deploying',
      );
      return typeof found !== 'undefined';
    },
  },
  props: {
    entry: Object,
    col: String,
    editName: String,
    flags: Array,
  },
};
</script>

<style lang="scss" scoped>
a {
  font-weight: 700;
}
</style>
